import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getUserLanguage, setUserLanguage } from '@/utils/userLanguage';

import commonEn from './locales/en/common.json';
import authEn from './locales/en/auth.json';
import tournamentEn from './locales/en/tournament.json';
import accountEn from './locales/en/account.json';
import adminEn from './locales/en/admin.json';
import landingEn from './locales/en/landing.json';
import leagueEn from './locales/en/league.json';
import matchEn from './locales/en/match.json';

import commonRu from './locales/ru/common.json';
import authRu from './locales/ru/auth.json';
import tournamentRu from './locales/ru/tournament.json';
import accountRu from './locales/ru/account.json';
import adminRu from './locales/ru/admin.json';
import landingRu from './locales/ru/landing.json';
import leagueRu from './locales/ru/league.json';
import matchRu from './locales/ru/match.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: commonEn,
        auth: authEn,
        tournament: tournamentEn,
        account: accountEn,
        admin: adminEn,
        landing: landingEn,
        league: leagueEn,
        match: matchEn,
      },
      ru: {
        common: commonRu,
        auth: authRu,
        tournament: tournamentRu,
        account: accountRu,
        admin: adminRu,
        landing: landingRu,
        league: leagueRu,
        match: matchRu,
      },
    },
    lng: getUserLanguage(),
    fallbackLng: 'en',
    supportedLngs: ['en', 'ru'],
    defaultNS: 'common',
    ns: ['common', 'auth', 'tournament', 'account', 'admin', 'landing', 'league', 'match'],
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on('languageChanged', (lng: string) => {
  setUserLanguage(lng as 'en' | 'ru');
  document.documentElement.setAttribute('lang', lng);
});

export default i18n;
